import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './List.module.css' 
import PrettyJSON from '../../../UI/PrettyJSON/PrettyJSON';  // Assuming PrettyJSON is defined in the same folder
import { useTranslation } from 'react-i18next';

const Item = ({ item }) => {
    const {t} = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
  
     
    const openAdd = () => { 
        setIsModalOpen(true)  
    }
 
  
    return (
        <div>

            <span className={ cl.logBtn } onClick={() => openAdd()} >
                {t('View')}
            </span>

            <Modal size="large" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
 
                <div className={cl.modalHead} >
                    <h3>{t('Log')}</h3>
                </div>
                <div className={ cl.precode }>
                    <PrettyJSON object={item.old} />  
                    <PrettyJSON object={item.new} />  
                </div>
            </Modal>
        </div>
    );
};

export default Item;